import { ArrowUpDown, ChevronRight } from 'lucide-react';
import { PhotoIdentite } from '../PhotoIdentite';
import { moyenneNormalisee } from '../../utils/normalizeNote';

export const pastilleCouleur = (v) => {
  if (v >= 8) return 'bg-green-100 text-green-800 ring-green-300';
  if (v >= 5) return 'bg-orange-100 text-orange-800 ring-orange-300';
  return 'bg-red-100 text-red-800 ring-red-300';
};

const Pastille = ({ notes, grande, testId }) => {
  if (!notes?.length) return <span className="text-slate-300">—</span>;
  const moy = moyenneNormalisee(notes);
  return (
    <span className="inline-flex flex-col items-center" data-testid={testId}>
      <span className={`inline-flex items-center justify-center rounded-full ring-1 font-bold ${pastilleCouleur(moy)} ${grande ? 'min-w-[56px] h-9 px-2 text-base' : 'min-w-[46px] h-8 px-2 text-sm'}`}>
        {moy.toFixed(1)}
      </span>
      <span className="mt-0.5 text-[11px] text-slate-400">{notes.length} note{notes.length > 1 ? 's' : ''}</span>
    </span>
  );
};

// Vue synthèse : une ligne par stagiaire, une moyenne par catégorie
export const SyntheseTable = ({ rows, categories, onSelect, onSort, sortCol }) => (
  <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="carnet-synthese-table">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-200 text-slate-600">
            <th className="sticky left-0 z-10 bg-slate-50 px-4 py-3 text-left font-semibold cursor-pointer whitespace-nowrap min-w-[150px] sm:min-w-[220px]" onClick={() => onSort('nom')}>
              Stagiaire {sortCol === 'nom' && <ArrowUpDown className="h-3.5 w-3.5 inline ml-1" />}
            </th>
            {categories.map(cat => (
              <th key={cat} className="px-3 py-3 text-center font-semibold whitespace-nowrap">{cat}</th>
            ))}
            <th className="px-4 py-3 text-center font-bold text-slate-800 cursor-pointer whitespace-nowrap border-l-2 border-slate-200" onClick={() => onSort('moyenne')}>
              Moyenne {sortCol === 'moyenne' && <ArrowUpDown className="h-3.5 w-3.5 inline ml-1" />}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.stagiaire_id} onClick={() => onSelect(r)} className="group border-b border-slate-100 cursor-pointer hover:bg-[#8DC63F]/5 transition-colors" data-testid={`synthese-row-${r.stagiaire_id}`}>
              <td className="sticky left-0 z-10 bg-white group-hover:bg-[#f7fbf1] px-4 py-3 transition-colors">
                <div className="flex items-center gap-3">
                  <PhotoIdentite
                    userId={r.stagiaire_id}
                    className="w-9 h-9 rounded-full object-cover flex-shrink-0"
                    fallback={<div className="w-9 h-9 rounded-full bg-[#8DC63F]/15 text-[#5f8f22] flex items-center justify-center text-xs font-bold flex-shrink-0">{r.prenom?.[0]}{r.nomFamille?.[0]}</div>}
                  />
                  <div className="min-w-0">
                    <p className="font-semibold text-slate-800 truncate max-w-[110px] sm:max-w-none">{r.prenom} {r.nomFamille}</p>
                    <p className="hidden sm:block text-xs text-slate-400 font-mono">{r.nim ? `NIM ${r.nim}` : '—'}</p>
                  </div>
                  <ChevronRight className="hidden sm:block h-4 w-4 ml-auto text-slate-300 group-hover:text-[#8DC63F] transition-colors" />
                </div>
              </td>
              {categories.map(cat => (
                <td key={cat} className="px-3 py-3 text-center">
                  <Pastille notes={r.liste.filter(n => (n.categorie || 'Autre') === cat)} />
                </td>
              ))}
              <td className="px-4 py-3 text-center border-l-2 border-slate-200">
                <Pastille notes={r.liste} grande testId={`synthese-moyenne-${r.stagiaire_id}`} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
